import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import apiFetchRouteManagementCreate from '../../api/RouteManagementCreateAPI';
import { ROUTE_CREATE_REQUEST } from '../actions/types/RouteManagementCreateActionsTypes';
import { postRouteCreateSuccessActionCreator, postRouteCreateFailureActionCreator } from '../actions/RouteManagementCreateActions';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* doRouteCreateWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const response = yield call(apiFetchRouteManagementCreate, action.payload);
    yield put(postRouteCreateSuccessActionCreator(response.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.route.create.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    let message = formatMessage(lang, 'app.server.error');
    if (error.response.data.BusinessError !== undefined) {
      message = formatMessage(lang, error.response.data.BusinessError.messageKey);
    }
    yield put(postRouteCreateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message,
    }));
  }
}

function* doRouteCreateWatcher() {
  yield takeLatest(ROUTE_CREATE_REQUEST, doRouteCreateWorker);
}

export default doRouteCreateWatcher;
